export default {
  type: "html-free",
  layout: "layouts/uk-coding",
  components: [
    require("fixtures/components/instructions.json"),
    require("fixtures/components/html-free-editor").default,
  ],
};
